module.exports = __webpack_public_path__ + "4263a06f4d3d0e7ab066e7145c58c992.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/es/google_store.png
// module id = 872
// module chunks = 0